// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2r39N","content":"styles_content__2d2KD","selectAll":"styles_selectAll__2t9DQ"};